<template>

    <div>

        <!-- DETAILED -->
        <template v-if="viewType=='detailed'">

            <div :class="[viewType, 'rectangle-box']">

                <div class="rectangle-content">

                    <div class="columns">
                        <draggable v-for="(column, index) in columns" :key="index" :data-index="column.index" element="div" class="column list-complete-item" :class="column.class" v-model="column.elements" :options="{ group: 'contentPageElements', animation: 0, draggable: '.contentPageElement', handle:'.drag-handle' }" @start="drag=true" @end="drag=false" @add="dragComplete($event)">
                            <layout-element :index="index" :pageNumber="column.pageIndex" :pageElement="column.elements[0]" :viewType="viewType" v-on:pageContextMenu="pageContextMenu" class="contentPageElement" @click.native="onClickContentPageElement($event, index, column)"></layout-element>
                        </draggable>
                    </div>

                    <div class="pageNumber left" v-if="showPageNumber(pages[0])">{{ calculatePageNumber(pages[0]) }}</div>
                    <div class="pageNumber right" v-if="showPageNumber(pages[1])">{{ calculatePageNumber(pages[1]) }}</div>

                </div> <!-- END rectangle-content -->

            </div> <!-- END rectangle-box -->


            <!-- CONTEXT MENU -->
          	<context-menu class="context-menu" ref="ctxMenu">

                <template v-if="currentItem != null && !currentItem.elements || currentItem.elements.length == 0 || currentItem.elements[0] == null">
                    <li @click="createElement()"><span class="icon is-small"><i class="icon-ak-hinzufuegen"></i></span>{{ $t("CONTEXT_MENU_SECTOR-NEW")}}</li>
                </template>

                <template v-else>
                    <li @click="changeElementType($event)"><span class="icon is-small"><i class="icon-ak-bearbeiten"></i></span>{{ $t("CONTEXT_MENU_SECTOR-CHANGE_TYPE")}}</li>
                    <li @click="editElement()"><span class="icon is-small"><i class="icon-ak-bearbeiten"></i></span>{{ $t("CONTEXT_MENU_SECTOR-EDIT")}}</li>
              		<li @click="deleteElement()"><span class="icon is-small"><i class="icon-ak-entfernen"></i></span>{{ $t("CONTEXT_MENU_SECTOR-DELETE")}}</li>
                </template>

          	</context-menu>

            <!-- MODAL (new page element) -->
            <modal :title="$t('CATALOG-NEW_PAGE_ELEMENT')" transition="fadeDownBig" :backdrop-closable="false" :is-show="showContentElementTypeSelection" @close="showContentElementTypeSelection=false">

                <div class="has-text-centered">
                    <div class="control is-expanded">
                        <span class="select is-medium is-fullwidth">
                            <select v-model="selectedContentElementType">
                                <option :value="null">- bitte wählen -</option>
                                <option v-for="(term, key) in contentElementTypes" :value="term">{{ $t('PAGE_ELEMENT_CONTENT_TYPE-' + key) }}</option>
                            </select>
                        </span>
                    </div>
                </div>

                <div slot="footer">
                    <a class="button" @click="showContentElementTypeSelection=false">Abbrechen</a>
                    <a class="button is-primary" :disabled="isCreatingNewPageElement" @click="createNewPageElement(true)">nur anlegen</a>
                    <a class="button is-primary" :disabled="isCreatingNewPageElement" @click="createNewPageElement">anlegen und bearbeiten</a>
                </div>

            </modal>


            <!-- MODAL (change content element type ) -->
            <modal :title="$t('CATALOG-CHANGE_ELEMENT_TYPE')" transition="fadeDownBig" :backdrop-closable="false" :is-show="showContentElementTypeSelection2" @close="showContentElementTypeSelection2=false">

                <div class="has-text-centered">
                    <div class="control is-expanded">
                        <span class="select is-medium is-fullwidth">
                            <select v-model="selectedContentElementType">
                                <option :value="null">- bitte wählen -</option>
                                <option v-for="(term, key) in contentElementTypes" :value="term">{{ $t('PAGE_ELEMENT_CONTENT_TYPE-' + key) }}</option>
                            </select>
                        </span>
                    </div>
                </div>

                <div slot="footer">
                    <a class="button" @click="showContentElementTypeSelection2=false">Abbrechen</a>
                    <a class="button is-primary" @click="onChangePageElementType(false)">ändern</a>
                    <a class="button is-primary" @click="onChangePageElementType(true)">ändern und bearbeiten</a>
                </div>

            </modal>


        </template>


        <!-- CATALOG CLUSTER  -->
        <template v-else-if="viewType=='cluster'">

            <div style="position:relative;" @contextmenu.prevent="pageContextMenuCatalog($event)">

                <div :class="[viewType, 'rectangle-box']">

                    <div class="rectangle-content">
                        <div class="columns">
                            <div v-for="(column, index) in columns" class="column list-complete-item" :key="column.page.id" :class="column.class">
                                <layout-element :index="index" :pageNumber="column.pageIndex" :pageElement="column.elements[0]" :viewType="viewType"></layout-element>
                            </div>
                        </div>

                        <div class="pageNumber left" v-if="showPageNumber(pages[0])">{{ calculatePageNumber(pages[0]) }}</div>
                        <div class="pageNumber right" v-if="showPageNumber(pages[1])">{{ calculatePageNumber(pages[1]) }}</div>

                    </div> <!-- END rectangle-content -->

                </div> <!-- END rectangle-box -->

            </div>


            <!-- CONTEXT MENU -->
            <context-menu class="context-menu" ref="ctxMenuCatalog">
                <li @click.stop="editDoublePage()"><span class="icon is-small"><i class="icon-ak-bearbeiten"></i></span>{{ $t("CONTEXT_MENU_CATALOG-PAGE_EDIT")}}</li>
                <li @click.stop="insertDoublePage()"><span class="icon is-small"><i class="fa icon-ak-hinzufuegen"></i></span>{{ $t("CONTEXT_MENU_CATALOG-PAGE_INSERT")}}</li>
                <li @click.stop="cloneDoublePage()"><span class="icon is-small"><i class="fa icon-ak-duplizieren"></i></span>{{ $t("CONTEXT_MENU_CATALOG-PAGE_DUPLICATE")}}</li>
                <li @click.stop="deleteDoublePage()"><span class="icon is-small"><i class="fa icon-ak-entfernen"></i></span>{{ $t("CONTEXT_MENU_CATALOG-PAGE_DELETE")}}</li>
            </context-menu>

        </template>

    </div>

</template>



<script>
import draggable from 'vuedraggable';
import contextMenu from 'vue-context-menu';
// import pageLayoutElement from './pageLayoutElement';
import layoutElement from './incl-catalogPageLayoutElement';

export default {

    name: 'catalogDoublePage',

    components: {
        layoutElement,
        contextMenu,
        draggable
    },

    props: {
        // value: {},

        pages: {
            type: Array,
            required: true
        },

        viewType: {
            type: String,
            required: true
        },

        showIsActive: {

        },

        pageLayoutChanged: {

        },

    },

    data() {

		return {
            currentItem: {},
            currentIndex: null,
            currentPageIndex: null,
            columns: [],
            selectedContentElementType: null,
            showContentElementTypeSelection: false,
            showContentElementTypeSelection2: false,
            isCreatingNewPageElement: false,
		}
	},

    computed: {

        catalogPageElementStatus() {

            return this.$store.getters.getTaxonomies.CATALOG_PAGE_ELEMENT_STATUS;

        },

        contentElementTypes() {

            return this.$store.getters.getTermsByTaxonomy('CONTENT_ELEMENT_TYPES');

        },

        pagesTotal() {

			return this.$store.getters.getCatalogPagesTotal;

		}

    },

    created() {

        this.getLayout();

    },

    mounted() {

	},

    updated() {

    },

    watch: {

        pageLayoutChanged() {

            if(this.userRole != 'Redaktion') {
                this.getLayout();
            }

        },

    },

    methods: {

        showPageNumber(page) {

            if(typeof page == 'undefined' || typeof page.sortorder == 'undefined' ) {
                return false;
            }

            if(page != null && page.section != null && (page.section.name.toLowerCase() == 'cover' || page.section.name.toLowerCase() == 'u4' || page.section.name.toLowerCase() == 'lesezeichen')
                || typeof page.sortorder == 'undefined'
                || page.sortorder == 0
                || page.sortorder == this.pagesTotal -1) {
                    return false;
            }

            return true;

        },

        calculatePageNumber(page) {

            return page.sortorder;

            if(page.section != null
                && (page.section.name.toLowerCase() == 'cover' || page.section.name.toLowerCase() == 'u4' || page.section.name.toLowerCase() == 'lesezeichen')
                || page.sortorder == 0
                || page.sortorder == this.pagesTotal-1) {
                    return false;
            }

            return true;

        },


        getLayout() {

            // this.pages = this.value;
            var columnCounts = {
                    'COLS_1': ['is-6'],
                    'COLS_2_2TO1': ['is-4', 'is-2'],
                    'COLS_2_1TO2': ['is-2', 'is-4'],
                    'COLS_3': ['is-2', 'is-2', 'is-2']
                },
                index = 0;

            this.columns = [];

            this.pages.forEach(function(page, pageIndex) {

                if(!page.pageLayout || typeof page.pageLayout.name == 'undefined') {
                    var layoutId = (typeof page.pageLayout == 'object' && page.pageLayout) ? page.pageLayout.id : page.pageLayout;
                    page.pageLayout = { id: layoutId || 1, name: 'COLS_1' };
                }

                columnCounts[page.pageLayout.name].forEach(function(columnClass, columnIndex) {

                    this.columns.push({
                        class: columnClass,
                        page: page,
                        index: index,
                        pageIndex: pageIndex,
                        columnIndex: columnIndex,
                        elements: [page.catalogPageElements.filter(function(i) { return i.sortorder == columnIndex; }).shift() || null]
                    });

                    index++;

                }, this);

            }, this);

            // console.log("updating ...");
            this.$emit('update:pages', this.pages);

        },

        onClickContentPageElement(el, index, column) {

            // page element alrady exists, redirect to the page
            if(this.viewType == 'detailed' && column.elements[0] != null && column.elements[0].id) {

                /*
                if(this.userRole == 'Redaktion' && this.catalogPageElementStatus.CREATED.id != column.elements[0].status.id && (this.pages[0].status.id != '13' || this.pages[0].status.id != '59' || column.elements[0].contentElement.type.name == 'PRODUCT')) {
                    return false;
                }
                */

                /*
                if(this.userRole == 'Redaktion' && this.catalogPageElementStatus.CREATED.id != column.elements[0].status.id && (this.pages[0].status.id != '52' || column.elements[0].contentElement.type.name == 'PRODUCT')) {
                    return false;
                }
                */

                var self = this;

                // save the double page before redirecting ...
                // this.pages[1].name = this.pages[0].name;
                // this.pages[1].manufacturer = this.pages[0].manufacturer;
                // this.pages[1].section = this.pages[0].section;
                // this.pages[1].catalog = this.pages[0].catalog;
                // this.pages[1].status = this.pages[0].status;
                // this.pages[1].thread = this.pages[0].thread;
                this.pages[1].section = this.pages[0].section;
                this.pages[1].catalog = this.pages[0].catalog = this.catalogId; // assign current catalog_id
                this.pages[1].isTopicIntro = this.pages[0].isTopicIntro;
                this.pages[1].thread = this.pages[0].thread;


                this.entityCreateOrUpdate('catalogPage', this.pages, { isSilent: true })
                    .then(function(res) {
                        self.$router.push( { name: 'catalogPageElement', params: { 'id': column.elements[0].id } })
                    });

            }

            // page element doesn't exist yet, create a new one
            else {

                // user "redaktion" is not allowed to create a new element
                if(this.userRole != 'Redaktion') {

                    this.currentPageIndex = column.pageIndex;
                    this.currentItem = this.columns[index];
                    this.createElement(index);

                }

            }

        },


        editDoublePage() {

            this.$emit('editDoublePage', this.pages[0].id, this.pages[1].id);

        },

        insertDoublePage() {

            this.$emit('insertDoublePage', this.pages[0].id, this.pages[1].id);

        },

        cloneDoublePage() {

            this.$emit('cloneDoublePage', this.pages[0].id, this.pages[1].id);

        },

        deleteDoublePage() {

            this.$emit('deleteDoublePage', this.pages[0].id, this.pages[1].id);

        },

        /* Context Menu Catalog View */
        pageContextMenuCatalog(payload) {

            if(this.userRole != 'Redaktion') {
                document.body.click();
                this.$nextTick(() => {
                    this.$refs.ctxMenuCatalog.open(payload);
                });
            }

        },

        /* Context Menu Detail View */
        pageContextMenu(payload) {

            if(this.userRole != 'Redaktion') {

                document.body.click();
                this.currentPageIndex = this.columns[payload[3]].pageIndex;
                this.currentItem = this.columns[payload[3]];

                // open context menu
                this.$nextTick(() => {
                    this.$refs.ctxMenu.open(payload[0]);
                });

            }

        },

        createElement() {

            if(this.userRole != 'Redaktion') {
                this.showContentElementTypeSelection = true;
            }

        },

        editElement() {
            // this.$router.push('/katalog/pageElement-' + this.currentItem.elements[0].id);
            this.$router.push( { name: 'catalogPageElement', params: { 'id': this.currentItem.elements[0].id } });
        },

        deleteElement() {

            var self = this;

            this.entityDelete('catalogPageElement', this.currentItem.elements[0].id, 'CONFIRMATION-DELETE_CATALOG_PAGE_ELEMENT')
                .then(function(response) {

                    // unset current item
                    self.currentItem.elements[0] = null;

                    // unset src data
                    for (var i = self.currentItem.page.catalogPageElements.length; i--;) {

                        if (self.currentItem.page.catalogPageElements[i].sortorder == self.currentItem.columnIndex) {
                            self.currentItem.page.catalogPageElements.splice(i, 1);
                        }

                    }

                    self.getLayout();

                });

        },


        changeElementType(evt) {

            if(this.userRole != 'Redaktion') {

                this.selectedContentElementType = this.currentItem.elements[0].contentElement.type;
                this.showContentElementTypeSelection2 = true;
            }

        },

        onChangePageElementType(redirect) {

            var self = this;

            this.axios.get(this.$config.api+'contentElement/'+this.currentItem.elements[0].contentElement.id+'/convertType?type='+this.selectedContentElementType.id+'&include=contentElement.contentElementData,contentElement.type')
                .then(function(response) {

                    if(redirect === true) {

                        // self.$router.push('/katalog/pageElement-' + self.currentItem.elements[0].id);
                        self.$router.push( { name: 'catalogPageElement', params: { 'id': self.currentItem.elements[0].id } });

                    } else {

                        self.columns[self.currentItem.index].elements[0].contentElement = response.data;
                        self.showContentElementTypeSelection2 = false;
                        self.currentItem = {};
                        self.selectedContentElementType = null;

                    }

                }).catch(function(error) {

                });

        },


        dragComplete(evt) {

            if(this.userRole == 'Redaktion') {
				return false;
			}

            // we added our contentPageElement to the list in column on index 'to',
            // our element list on column 'from' is now empty, let's move the second
            // element from the 'to' list back to the 'from' list to simulate a switch
            var srcColumn = this.columns[evt.from.dataset.index],
                targetColumn = this.columns[evt.to.dataset.index],
                updateList = [];

            srcColumn.elements.push(targetColumn.elements.splice(1, 1).shift());

            if (srcColumn.elements[0]) {

                srcColumn.elements[0].sortorder = srcColumn.columnIndex;
                srcColumn.elements[0].catalogPage = srcColumn.page.id;

                updateList.push(srcColumn.elements[0]);

            }

            if (targetColumn.elements[0]) {

                targetColumn.elements[0].sortorder = targetColumn.columnIndex;
                targetColumn.elements[0].catalogPage = targetColumn.page.id;

                updateList.push(targetColumn.elements[0]);

            }

            this.entityCreateOrUpdate('catalogPageElement', updateList);

        },


        createNewPageElement(createOnly=false) {

            // user didn't choose an elementType....
            if (this.selectedContentElementType == null) {

                this.$notify.open( {content: 'Bitte wählen Sie einen Inhaltstyp aus!', type: 'warning'} );

            // create a new element
            } else {

              this.isCreatingNewPageElement = true;

              // we're on a completely new page, so we've to save the page first
              // in order to get a new page id
              if(typeof this.pages[this.currentPageIndex].id == 'undefined') {


                  var newPages = [this.pages[0], this.pages[1]];

                  this.entityCreateOrUpdate('catalogPage', newPages, { isSilent: true })
                      .then((response) => {

                          // assign the new ids
                          for(var i=0; i < 2; i++) {
                            this.pages[i].id = response.catalogPage[i].id;
                          }

                          // change the history (important when navigating away and then back)
  					              this.$router.replace( { name: 'catalogPage', params: { 'page1ID': this.pages[0].id, 'page2ID':this.pages[1].id } });

                          this._insertPageElement(createOnly);

                      })

                } else {

                    this._insertPageElement(createOnly);

                }

            }

        },

        _insertPageElement(createOnly=false) {

            var catalogPageElement = {
                catalogPage: this.pages[this.currentPageIndex].id,
                contentElement: {
                    type: this.selectedContentElementType
                },
                status: this.catalogPageElementStatus.CREATED,
                sortorder: this.currentItem.columnIndex
            }

            // var self = this;

            this.entityCreateOrUpdate('catalogPageElement', catalogPageElement, { isSilent: false })
                .then((res) => {

                    this.showContentElementTypeSelection = false;

                    if(createOnly === true) {

                        catalogPageElement.id = res.id;
                        this.columns[this.currentItem.index].elements[0] = catalogPageElement;
                        this.pages[this.currentPageIndex].catalogPageElements.push(catalogPageElement);

                        // console.log("ok: ", this.pages);
                        this.$emit('update:pages', this.pages);
                        this.$emit('save', { isSilent: true });

                        this.isCreatingNewPageElement = false;
                    }

                    // if the user pushed "anlegen und bearbeiten",
                    // we want the user to be automatically redirected to the new page
                    else {

                        this.$router.push( { name: 'catalogPageElement', params: { 'id': res.id } });

                    }

                });


        }

    },

}

</script>



<style lang="scss">

    @import '../../assets/css/variables.scss';

    .cluster.rectangle-box .prop-inner {
        border-top: none !important;
    }


    /* status border for detailed views */
    .rectangle-box.detailed .status-CREATED .prop-wrap {
        border-top: 8px solid $statusCreated;
    }
    .rectangle-box.detailed .status-READY .prop-wrap {
        border-top: 8px solid $statusReady;
    }
    .rectangle-box.detailed .status-EDITED .prop-wrap {
        border-top: 8px solid $statusEdited;
    }
    .rectangle-box.detailed .status-LAYOUTED .prop-wrap {
        border-top: 8px solid $statusLayouted;
    }
    .rectangle-box.detailed .status-REVISED .prop-wrap {
        border-top: 8px solid $statusRevised;
    }
    .rectangle-box.detailed .status-APPROVED .prop-wrap {
        border-top: 8px solid $statusApproved;
    }
    .rectangle-box.detailed .status-PRINT_APPROVED .prop-wrap {
        border-top: 8px solid $statusPrintApproved;
    }
    .rectangle-box.detailed .status-PRINT_APPROVAL .prop-wrap {
        border-top: 8px solid $statusPrintApproval;
    }
    .rectangle-box.detailed .status-REVIEW .prop-wrap {
        border-top: 8px solid $statusReview;
    }


    /* status circles */
    .statusCircle.CREATED {
        background: $statusCreated !important;
    }
    .statusCircle.READY {
        background: $statusReady !important;
    }
    .statusCircle.EDITED {
        background: $statusEdited !important;
    }
    .statusCircle.LAYOUTED {
        background: $statusLayouted !important;
    }
    .statusCircle.REVISED {
        background: $statusRevised !important;
    }
    .statusCircle.APPROVED {
        background: $statusApproved !important;
    }
    .statusCircle.PRINT_APPROVED {
        background: $statusPrintApproved !important;
    }
    .statusCircle.PRINT_APPROVAL {
        background: $statusPrintApproval !important;
    }
    .statusCircle.REVIEW {
        background: $statusReview !important;
    }

    /* pageElementTypes */
    .column > .pageElementType-RICH_TEXT {
    	background: $elementTypeRICHTEXT !important;
    }
    .column > .pageElementType-NEU_AM_MARKT,
    .column > .pageElementType-HAUSAPOTHEKE,
    .column > .pageElementType-PRODUCT {
    	background: $elementTypePRODUCT !important;
    }
    .column > .pageElementType-ADVICE {
        background: $elementTypeADVICE !important;
    }
    .column > .pageElementType-EXPERT_ADVICE {
        background: $elementTypeEXPERTADVICE !important;
    }
    .column > .pageElementType-APOPEDIA {
        background: $elementTypeAPOPEDIA !important;
    }
    .column > .pageElementType-RECIPE {
        background: $elementTypeRECIPE !important;
    }
    .column > .pageElementType-PUZZLE {
        background: $elementTypePUZZLE !important;
    }


</style>

<style>

    /* CONTEXT MENU STYLE */
    .ctx-menu-container {
        position: fixed;
        padding: 0 !important;
        border: none !important;
        outline: none !important;
        height: 0;
        width: 0;
    }
    .ctx-menu {
        padding: 5px 4px;
        width: auto;
        background: #fff !important;
        border: 1px solid #c5c5c5 !important;
        border-radius: 0 !important;
        -webkit-box-shadow: 3px 3px 10px 0px rgba(0,0,0,0.3);
        -moz-box-shadow: 3px 3px 10px 0px rgba(0,0,0,0.3);
        box-shadow: 3px 3px 10px 0px rgba(0,0,0,0.3) !important;
    }
    .ctx-menu li {
        padding: 5px 8px !important;
        cursor: pointer;
        white-space: nowrap;
    }
    .ctx-menu li:hover {
        background: #eee;
    }
    .ctx-menu li .icon {
        /*
        font-size: 20px !important;
        line-height: 20px !important;
        */
        margin-right: 8px;
    }


    /* RECTANGLE BOX (columns wrapper)*/
    .rectangle-box {
        position: relative;
        width: 100%;
        max-width: 1600px;
        padding: 0;
        margin: 0 auto;
        background: transparent url('../../assets/img/bg-pages.jpg') no-repeat 45% 12%;
        background-size: 98%;
    }
    .rectangle-box:before {
        content: "";
        display: block;
        padding-top: 47%;
    }
    .rectangle-content {
        position: absolute;
        top: 3.4%;
        left: 2.1%;
        right: 2.7%;
        /*bottom: 10%;*/
        bottom: 5%;
    }

    /* PAGE LAYOUT COLUMNS */
    .rectangle-content > .columns {
        position: absolute;
        right: 1% !important;
        left: 1% !important;
        top: 1% !important;
        bottom: 1%;
        padding: 0 !important;
        margin: 0 !important;
    }
    .rectangle-content > .columns .column {
        margin: 0 !important;
        padding: .8% !important;
        position: relative !important;
        overflow: hidden;
        height: 100%;
    }
    .rectangle-content > .columns > .column > div.inner {
        position: relative;
        padding: 0 !important;
        margin: 0 !important;
        border: 1px dotted #ccc;
        transition: background .3s ease, border-color .3s ease;
        font-size: 0.8vw;
        cursor: pointer;
        height: 100%;
    }
    .rectangle-content > .columns .column > div.inner:hover {
        border: 1px dotted #000;
    }

    /* columns which already have a content element set should get another border */
    .rectangle-content > .columns > .column > div.inner[class*="pageElementType"] {
        border: 1px solid rgba(150,150,150,0.2);
    }
    .rectangle-content > .columns > .column > div.inner[class*="pageElementType"]:hover {
        border: 1px solid rgba(150,150,150,0.8);
    }
    .rectangle-box.detailed .contentPageElement {
        background: #fff !important;
        overflow: hidden;
    }


    .column > div > .pageElementType {
        display: block;
        width: 3vw;
        height: 3vw;
        margin: 0;
        position: absolute;
        top: 50%;
        left: 50%;
        margin-right: -50%;
        transform: translate(-50%, -50%);
        text-align: center;
    }
    .column > div > .pageElementType i {
        font-size: 1.8rem;
        color: rgba(0,0,0,0.3);
        transition: color .3s ease;
        position: absolute;
        top: 50%;
        left: 50%;
        margin-right: -50%;
        transform: translate(-50%, -50%);
        transition: color .3s ease;
    }


    .column > div > .statusCircle {
        display: block;
        width: .6rem;
        height: .6rem;
        border-radius: .6rem;
        margin: 0;
        position: absolute;
        top: 50%;
        left: 50%;
        margin-right: -50%;
        transform: translate(-50%, -50%);
        text-align: center;
    }


    /* CSS Styles for non detailed views */
    .rectangle-box:not(.detailed) {
        cursor: pointer !important;
    }
    .rectangle-box:not(.detailed) .rectangle-content:hover {
        transition: .2s filter linear;
        -webkit-transition: .2s -webkit-filter linear;
        -moz-transition: .2s -moz-filter linear;
        -ms-transition: .2s -ms-filter linear;
        -o-transition: .2s -o-filter linear;

        -webkit-filter: blur(3px);
        -moz-filter: blur(3px);
        -o-filter: blur(3px);
        -ms-filter: blur(3px);
        filter: blur(3px);
        cursor: pointer !important;
    }
    .rectangle-box:not(.detailed) .rectangle-content > .columns > .column > div.inner {
        border: 1px solid #ddd;
        transition: none;
        cursor: inherit;
    }
    .rectangle-box:not(.detailed) .rectangle-content > .columns > .column > div.inner:hover {
        border: 1px solid #ddd;
    }

    .rectangle-content .pageNumber {
        position: absolute;
        z-index: 0 !important;
        bottom: 0;
        width: .7vw;
        height: .7vw;
        line-height: .7vw;
        background-color: #fff;
        color: #888;
        z-index: 9999;
        font-size: 50%;
        text-align: center;
    }
    .rectangle-content .pageNumber.left {
        left: .2%;
    }
    .rectangle-content .pageNumber.right {
        right: .2%;
    }

    .detailed .pageNumber {
        width: 1vw;
        height: 1vw;
        line-height: 1vw;
        font-size: 70%;
        background-color: transparent;
    }
</style>


<style scoped>
    .sortable-ghost {
        opacity: 0.6 !important;
    }
    .sortable-drag {
    }
</style>
